import { useTheme } from '@emotion/react'

import { ChevronLeftIcon, ChevronRightIcon } from '@twistopayments/design-system/icons/inline'

import * as styles from './pagination.styles'

type Props = {
  currentPage: number
  pagesNeeded: number
  onPageChange: (page: number) => void
  type: 'forward' | 'backward'
}

export const PaginationArrowButton = ({
  currentPage,
  onPageChange,
  type,
  pagesNeeded,
}: Props) => {
  const theme = useTheme()
  const arrowIcon =
    type === 'forward' ? (
      <ChevronRightIcon color="inherit" size="inherit" />
    ) : (
      <ChevronLeftIcon color="inherit" size="inherit" />
    )

  const handleOnClick = () => {
    if (type === 'backward') {
      return onPageChange(currentPage - 1)
    }

    onPageChange(currentPage + 1)
  }

  return (
    <button
      css={styles.arrowButton(theme)}
      data-testid="pagination-arrow-button"
      disabled={
        type === 'forward' ? currentPage === pagesNeeded : currentPage === 1
      }
      onClick={handleOnClick}
    >
      {arrowIcon}
    </button>
  )
}
